import GenericBinding from './GenericBinding';

var NumericBinding = (function (GenericBinding) {
	function NumericBinding () {
		GenericBinding.apply(this, arguments);
	}

	if ( GenericBinding ) NumericBinding.__proto__ = GenericBinding;
	NumericBinding.prototype = Object.create( GenericBinding && GenericBinding.prototype );
	NumericBinding.prototype.constructor = NumericBinding;

	NumericBinding.prototype.getInitialValue = function getInitialValue () {
		return undefined;
	};

	NumericBinding.prototype.getValue = function getValue () {
		var value = parseFloat( this.node.value );
		return isNaN( value ) ? undefined : value;
	};

	NumericBinding.prototype.setFromNode = function setFromNode ( node ) {
		var value = parseFloat( node.value );
		if ( !isNaN( value ) ) { this.model.set( value ); }
	};

	return NumericBinding;
}(GenericBinding));

export default NumericBinding;

//# sourceMappingURL=/home/travis/build/ractivejs/ractive/.gobble-build/01-transpile/.cache/view/items/element/binding/NumericBinding.js.map
